// Unica fonte di verita lato client per le costanti di gioco.
// La controparte server e backend/app/domain/constants.py; il test
// test_defaults_match_frontend confronta le due tramite /api/config/defaults.

export const ROLES = ['P', 'D', 'C', 'A'];

export const PHASE_ORDER = ['P', 'D', 'C', 'A'];

export const ROLE_LABELS = {
    P: 'Portieri',
    D: 'Difensori',
    C: 'Centrocampisti',
    A: 'Attaccanti',
};

export const ROLE_ICONS = { P: '🥅', D: '🛡️', C: '♟️', A: '🗡️' };

// Convenzione cromatica del fantacalcio: i partecipanti la riconoscono gia da
// ogni sito di settore, quindi una rosa si scorre a colpo d'occhio. I valori
// veri stanno in styles/tokens.css come --role-p/d/c/a; qui ci sono i nomi
// delle variabili, cosi il colore resta definito in un posto solo.
export const ROLE_COLOR_VARS = {
    P: 'var(--role-p)',
    D: 'var(--role-d)',
    C: 'var(--role-c)',
    A: 'var(--role-a)',
};

export const DEFAULT_PLAYERS_PER_TEAM = { P: 3, D: 8, C: 8, A: 6 };

// L'asta di riparazione parte da un budget piu basso: le rose esistono gia.
export const DEFAULT_BUDGET = { live: 500, repair: 250 };

export const DEFAULT_NUM_PARTICIPANTS = 8;
export const DEFAULT_AUCTION_TIMER = 20;
export const DEFAULT_BID_TIMER = 10;

export const BID_INCREMENTS = [1, 5, 10];

export const PROTOCOL_VERSION = 1;

export const MODES = { LIVE: 'live', REPAIR: 'repair' };

export const MODE_LABELS = {
    live: 'Asta Live',
    repair: 'Asta di Riparazione',
};

// Stati della macchina a stati del server.
export const STATES = {
    SETUP: 'setup',
    NOMINATING: 'nominating',
    BIDDING: 'bidding',
    AWAITING_CONFIRM: 'awaiting_confirm',
    PHASE_BREAK: 'phase_break',
    FINISHED: 'finished',
};

// Come esce il prossimo giocatore all'asta, in accordo con
// backend/app/domain/enums.py. La modalita la sceglie il banditore a partita
// in corso: non e un'impostazione della lobby.
export const CALL_MODES = {
    FREE: 'free',
    RANDOM: 'random',
    FVM: 'fvm',
    ALPHA: 'alpha',
};

export const CALL_MODE_LABELS = {
    free: 'Libera',
    random: 'Casuale',
    fvm: 'Ordine FVM',
    alpha: 'Alfabetico',
};

// Di chi e la base d'asta di un giocatore estratto.
export const BASE_HOLDERS = { NOBODY: 'nobody', TURN: 'turn' };

export const BASE_HOLDER_LABELS = {
    nobody: 'A nessuno',
    turn: 'Di turno',
};

// Soglia oltre la quale i due pannelli si affiancano e la maniglia dello split
// diventa trascinabile. Deve combaciare con `@media (min-width: 64rem)` in
// styles/layout.css: se le due divergono, JavaScript applica larghezze inline
// mentre il CSS impila i pannelli, ed e' esattamente il difetto che rompeva il
// layout sul telefono.
export const SPLIT_BREAKPOINT = 1024;

// Codici di chiusura del websocket, in accordo con backend/app/protocol.py.
// Il testo mostrato all'utente lo sceglie il client: il frame di chiusura
// porta solo il codice, e il suo campo `reason` ha un limite di 123 byte.
export const CLOSE_CODES = {
    REMOVED: 4001,
    REPLACED: 4003,
    LOBBY_NOT_FOUND: 4400,
    BAD_TOKEN: 4401,
    LOBBY_CLOSED: 4402,
};

export const LOBBY_CLOSED_MESSAGE =
    'Il banditore ha chiuso la lobby. Sei stato disconnesso.';
